import { apiFetch } from '@/lib/api';

export interface AiModel {
  model: string;
  provider: 'anthropic' | 'openai' | 'deepseek' | 'qwen';
  apiModelId: string;
  inputPrice: number;
  outputPrice: number;
  supportsVision: boolean;
  acceptsPdfNatively: boolean;
  enabled: boolean;
}

export function getAiModels(): Promise<AiModel[]> {
  return apiFetch<AiModel[]>('/ai-models');
}
export function createAiModel(
  body: Partial<AiModel> & { model: string; provider: string; inputPrice: number; outputPrice: number },
): Promise<AiModel> {
  return apiFetch<AiModel>('/ai-models', { method: 'POST', body: JSON.stringify(body) });
}
export function updateAiModel(model: string, body: Partial<AiModel>): Promise<AiModel> {
  return apiFetch<AiModel>(`/ai-models/${encodeURIComponent(model)}`, { method: 'PUT', body: JSON.stringify(body) });
}
export function deleteAiModel(model: string): Promise<{ status: string }> {
  return apiFetch(`/ai-models/${encodeURIComponent(model)}`, { method: 'DELETE' });
}
